import React from 'react'
import IconStar from '../svgs/Star'

interface Props {
  text: string
}

const Sticker: React.FunctionComponent<Props> = ({text}) => {
  return <>
    <div className="sub-builder-sticker">
      <IconStar />
      <span>{text}</span>
      <IconStar />
    </div>
  </>
}

export default Sticker